/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusDownLeftIcon20Solid = forwardRef('ArrowShapeDRadiusDownLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 17.044c0 1.113-1.346 1.67-2.134.883l-6.69-6.689a1.75 1.75 0 0 1 0-2.475l6.69-6.69C8.654 1.287 10 1.845 10 2.959V6c1.32-.007 2.358-.055 3.394-.396 1.14-.375 2.343-1.132 3.866-2.746.575-.609 1.692-.292 1.728.641.14 3.694-.916 6.354-2.738 8.084-1.687 1.601-3.94 2.32-6.25 2.408v3.053Z" })));
});
